/**
 * Component to display the Expandable pane
 *
 */

import React, { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import {
    Overlay,
    Spinner,
    SpinnerSize,
    Stack,
    mergeStyleSets,
} from '@fluentui/react';
import { resolveThemeColors } from '../../helpers';
import { WAITING_PANEL_MAX_WIDTH } from '../../helpers/constants';
import { useAppSelector } from '../../store';

const Waiting = () => {
    const uiState = useAppSelector((state) => state.uiReducer);
    const { isFetched, operations } = useAppSelector(
        (state) => state.appReducer.longOperation,
    );
    const colors = useAppSelector(resolveThemeColors, shallowEqual);

    const styles = useMemo(
        () =>
            mergeStyleSets({
                root: {
                    background: colors.popupBg,
                    maxWidth: WAITING_PANEL_MAX_WIDTH,
                    padding: 20,
                    margin: '20px auto',
                },
                waitingText: {
                    paddingTop: 10,
                    margin: 0,
                    fontSize: 14,
                    color: colors.appBgText,
                    textAlign: 'center',
                },
                waitingPanel: {
                    position: 'relative',
                    top: '40%',
                    transform: 'translateY(-40%)',
                },
            }),
        [colors],
    );

    const operation = operations[0];

    if (!isFetched || !operation) {
        return null;
    }

    const getSpinner = () => (
        <Stack tokens={{ childrenGap: 15 }} className={styles.root}>
            <Spinner size={SpinnerSize.large} />
            <div className={styles.waitingText}>
                {uiState.translate(operation.message)}
            </div>
        </Stack>
    );

    const DarkOverlay = () => (
        <Overlay isDarkThemed={true}>
            <div className={styles.waitingPanel}>{getSpinner()}</div>
        </Overlay>
    );

    return (
        <div>
            <DarkOverlay />
        </div>
    );
};

export default Waiting;
